"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ValidationRender_1 = __importDefault(require("./ValidationRender"));
/**
 * This component is used to ensure that the full validation function isn't created for simple required field, or nonexistent validations.
 * Full validation requires subscribing to formstate changes, which can be expensive, by placing this component in front of the
 * actual validation creation, we can optimize and skip that subscription
 * @param controlDefinition the control to validate
 */
const ValidationOptimizer = (props) => {
    const { controlDefinition: { computedMap, warningMap, errorMap, label }, render, displayMap } = props;
    // we're going to create a validation function that returns errors and warnings
    if (warningMap || errorMap || computedMap || displayMap) {
        // in this case we have to fall back to rendering using the full validation function
        return react_1.default.createElement(ValidationRender_1.default, { displayMap: displayMap, controlDefinition: props.controlDefinition, render: render });
    }
    else {
        return render(undefined); //<Component {...props} />;
    }
};
exports.default = ValidationOptimizer;
